import { formatDate } from "global/Utility/TSFunctions";
import {
    EGroupConfigurationStatus as FAM_EGroupConfigurationStatus,
    IGroupConfigurationData as FAM_IGroupConfigurationData
} from "./FlexibleAttributeModel";

export const blankSnapshot = () => {
    const ret: FAM_IGroupConfigurationData = {
        id: '00000000-0000-0000-0000-000000000000',
        name: '',
        bcbs_shortname: '',
        iteration: 10001,
        changeType: {
            type: 'optionset',
            name: 'Initial Setup',
            value: 808900002
        },
        fundingType: null,
        dualFunded: { type: "bool", value: false },
        MNIL: { type: 'bool', value: false },
        grandFathered: {
            type: 'optionset',
            name: 'Non-Grandfathered',
            value: 808900000
        },
        lineOfBusiness: null,
        effectiveDate: null,
        operativeDate: {
            type: 'date',
            value: formatDate(new Date(), 'local:yyyy-MM-dd')
        },
        erisa: null,
        fields: [],
        nonStandards: [],
        nonStandardTemplates: [],
        attributeSets: [],
        plans: [],
        benefits: [],
        feesAndPremiums: [],
        groupStructure: {
            departments: [],
            groupNumbers: [],
            cesNumbers: []
        },
        claimsARs: [],
        comments: [],
        stopLoss: [],
        showInActives: {
            type: 'bool',
            value: false
        },
        reconciliation: {
            type: 'bool',
            value: false
        },
        status: {
            name: FAM_EGroupConfigurationStatus[FAM_EGroupConfigurationStatus["Active"]],
            type: "optionset",
            value: FAM_EGroupConfigurationStatus["Active"]
        },
        isRevision: {
            type: 'bool',
            value: false,
        },
        revisionTasks: [],
        appVersion: (process.env.REACT_APP_VERSION) ?? "",
        transformers: {
            Sprint17: true,
            Sprint18: true,
            Sprint21: true,
            Sprint22: true,
            Sprint24: true,
            Sprint30: true,
            Sprint33: true,
            Sprint33PatchTransformer: true,
            Sprint34: true,
            Sprint35: true,
            Sprint40: true,
        }
    }

    return ret;
}